import request from '@/utils/request'

// 发起拼单（开团）
export const createGroupApi = ({ goodsId, goodsNum, goodsSkuId }) => {
  return request.post('/group/create', {
    goodsId,
    goodsNum,
    goodsSkuId
  })
}

// 参与拼单（参团）
export const joinGroupApi = ({ groupNo, goodsId, goodsNum, goodsSkuId }) => {
  return request.post('/group/join', {
    groupNo,
    goodsId,
    goodsNum,
    goodsSkuId
  })
}

// 拼团详情（分享链接打开，无需登录可查看）
export const getGroupDetailApi = (groupNo) => {
  return request.get('/group/detail', {
    params: {
      groupNo
    }
  })
}

// 我的拼单列表
export const getMyGroupsApi = () => {
  return request.get('/group/mine')
}
